import { lazy } from 'react';
import PrivateRoute from '../../components/common/Router/PrivateRoute/PrivateRoute';

const List = lazy(() => import('./List'));
const Update = lazy(() => import('./Update'));

const MiembrosRoutes = [
  {
    path: 'miembros',
    children: [
      {
        index: true,
        element: (
          <PrivateRoute
            allowedPermissions={['read_miembro']}
            component={List}
          />
        ),
      },
      {
        path: ':id/editar',
        element: (
          <PrivateRoute
            allowedPermissions={['update_miembro']}
            component={Update}
          />
        ),
      },
    ],
  },
];

export default MiembrosRoutes;
